import React from "react";

const ATSScore = ({ score }) => {
  return <h3 className="ats-score">{score}</h3>;
};

export default ATSScore;
